module.exports = Promise.all([__parcel__import__("iFuww"), __parcel__import__("cOqeX")]).then(() => parcelRequire('g36Vt'));